import { AccountCircle, Lock } from '@mui/icons-material';
import { Button, InputAdornment, Stack } from '@mui/material';
import type { FormEvent } from 'react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ACCESS_TOKEN_KEY, ID_TOKEN_KEY } from '../../../constants';
import { Me } from '../../../context';
import { useTry } from '../../../hooks';
import { RestClient } from '../../../lib';
import { ContentBox } from '../../../styles/LoginContainerStyle';
import { WhiteTextField } from '../../../styles/WhiteTextFieldStyle';
import type { Account, AuthResult } from '../Login.type';
import { SignInErrors, validateSignInForm } from '../services';

export function LoginForm() {
  const navigate = useNavigate();
  const { tryReq } = useTry();
  const [errors, setErrors] = useState<SignInErrors>({});
  const [formData, setFormData] = useState<Account>({ email: '', password: '' });

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setErrors({});
    const errors = validateSignInForm(formData);
    if (Object.keys(errors).length !== 0) {
      setErrors(errors);
      return;
    }

    await tryReq(
      async () => {
        const res = await RestClient.post<AuthResult>('/login', formData);
        if (res.type === 'changeRequired') {
          navigate('/new-password', { state: { session: res.session, email: res.email } });
        } else {
          localStorage.setItem(ID_TOKEN_KEY, res.idToken);
          localStorage.setItem(ACCESS_TOKEN_KEY, res.accessToken);
          // get user type
          const me = await RestClient.post<Me>('/me', {
            accessToken: res.accessToken,
          });
          if (me.type === 'admin') {
            navigate('/dashboard');
          } else {
            navigate('/environment');
          }
        }
      },
      { redirectWhenAuthError: false },
    );
  };

  return (
    <ContentBox>
      <form onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <h2 style={{ margin: 0 }}>ログイン</h2>

          <WhiteTextField
            label="User"
            id="email"
            name="email"
            fullWidth
            focused
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              },
            }}
            value={formData.email}
            onChange={(e) => {
              setFormData({ ...formData, email: e.target.value });
            }}
            error={!!errors.username}
            helperText={errors.username}
          />

          <WhiteTextField
            name="password"
            id="password"
            fullWidth
            focused
            size="small"
            label="Password"
            type="password"
            autoComplete="current-password"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
              },
            }}
            value={formData.password}
            onChange={(e) => {
              setFormData({ ...formData, password: e.target.value });
            }}
            error={!!errors.password}
            helperText={errors.password}
          />

          <Link
            to="/reset-password"
            style={{
              color: '#000000',
              fontSize: 14,
              fontWeight: 'bold',
              textDecoration: 'underline',
            }}
          >
            パスワード忘れた場合
          </Link>

          <Button type="submit">Login</Button>
        </Stack>
      </form>
    </ContentBox>
  );
}
